import React, { useEffect, useState } from 'react';
import './gallery.css';
import { db } from '../../config/firebase'; // Ensure the import path
import { collection, getDocs } from 'firebase/firestore';
import { BiX } from 'react-icons/bi';

const Gallery = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [images, setImages] = useState([]);

    useEffect(() => {
        const fetchImages = async () => {
            const querySnapshot = await getDocs(collection(db, 'gallery'));
            const imagesList = querySnapshot.docs.map(doc => doc.data());
            setImages(imagesList);
        };

        fetchImages();
    }, []);

    const handleImageClick = (index) => {
        setCurrentIndex(index);
        setShowModal(true);
    };

    const handleNextImage = () => {
        setCurrentIndex((currentIndex + 1) % images.length);
    };

    const handlePrevImage = () => {
        setCurrentIndex((currentIndex - 1 + images.length) % images.length);
    };

    return (
        <div className='gallery_container'>
            <div className='gallery_heading'>
                <h1>The moment captured</h1>
                <h2>Preserving life's precious moments, one click at a time</h2>
            </div>
            <div className='gallery'>
                {images.length > 0 ? (
                    images.map((image, index) => (
                        <div className='grid-cell' key={index}>
                            <img src={image.imageUrl} alt={image.title} onClick={() => handleImageClick(index)} />
                        </div>
                    ))
                ) : (
                    <div className='no_images'>
                        <p>No images uploaded</p>
                    </div>
                )}
                {showModal && (
                    <div
                        className='modal'
                        onClick={(e) => {
                            if (e.target.classList.contains('modal')) {
                                setShowModal(false);
                            }
                        }}
                    >
                        <div className='modal-content'>
                            <img src={images[currentIndex].imageUrl} alt={images[currentIndex].title} />
                            <p>{currentIndex + 1} / {images.length}</p>
                            <button
                                className='prev_btn'
                                onClick={handlePrevImage}
                                disabled={currentIndex === 0}
                            >
                                Prev
                            </button>
                            <button className='next_btn' onClick={handleNextImage}>
                                Next
                            </button>
                            <BiX onClick={() => setShowModal(false)} className='closing' />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Gallery;
